<template>
    <reports-base
        :page-size-changeable="isLotteryReportAdvancedDisplay"
        reportsName="lotteryUsage"
        reportsTitle="Raport/ Użycia loterii"
        :componentName="
            isLotteryReportAdvancedDisplay
                ? 'LotteryUsageAdvanced'
                : 'LotteryUsageSimple'
        "
        @onExport="onExport"
    >
        <div
            v-if="isLotteryReportAdvancedDisplay"
            class="c-thead lottery-usage-advanced"
        >
            <div class="c-tw w-left">
                <div class="c-td is-1">Nazwa loterii</div>
                <div class="c-td is-2">Nazwa sklepu / Adres sklepu</div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-4 text-center">Spalony kod</div>
                <div class="c-td is-5 text-center">Kwota refundacji netto</div>
                <div class="c-td is-6">Data oraz godzina użycia</div>
            </div>
        </div>
        <div v-else class="c-thead lottery-usage-simple">
            <div class="c-tw w-left">
                <div class="c-td is-1">Nazwa loterii</div>
                <div class="c-td is-2">Nazwa sklepu / Adres sklepu</div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-4 text-center">Liczba spalonych kodów</div>
                <div class="c-td is-5 text-center">Kwota refundacji netto</div>
            </div>
        </div>
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    components: {
        ReportsBase
    },
    computed: {
        isLotteryReportAdvancedDisplay() {
            return this.$store.getters.isLotteryReportAdvancedDisplay
        }
    },
    methods: {
        onExport() {
            this.$store.dispatch('fetchPromotionUsageReport')
        }
    }
}
</script>
